<template>
  <div></div>
</template>

<script>
export default {
  mounted() {
    this.$store.dispatch('auth/userLogout', { router: this.$router });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Logout.vue